import axios from "axios";

// Use relative path in development to leverage Vite proxy (avoids CORS)
// In production, use the full URL from env or default
const API_URL = import.meta.env.DEV
  ? "/api/admin" // Relative path uses Vite proxy in development
  : import.meta.env.VITE_API_BASE_URL || "https://api.prokopi.in/api/admin";

const adminApi = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle errors
// Note: Token refresh is handled by authApi interceptor
// This interceptor just handles cleanup on 401
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // If token refresh fails, authApi will handle logout
      // This is just a fallback
      const refreshTokenValue = localStorage.getItem("refreshToken");
      if (!refreshTokenValue) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("tokenExpiry");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default adminApi;
